/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignScheduleUpdatePathParams,
	CampaignScheduleUpdateRequest,
	CampaignScheduleUpdateResponse,
} from '../types/CampaignScheduleUpdate'

/**
 * PATCH /campaigns/:campaign/schedule
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignScheduleController.php CampaignScheduleController::update
 */
export async function campaignScheduleUpdate(
	campaign: CampaignScheduleUpdatePathParams['campaign'],
	data: CampaignScheduleUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignScheduleUpdateResponse>> {
	return axiosInstance.patch(`/campaigns/${campaign}/schedule`, data, config)
}
